import { useEffect, useState } from 'react';
import { getDemoInfo } from '../api';

function formatInterval(seconds) {
    if (!seconds) return null;
    if (seconds % 3600 === 0) {
        const h = seconds / 3600;
        return h === 1 ? 'hour' : `${h} hours`;
    }
    const m = Math.round(seconds / 60);
    return m === 1 ? 'minute' : `${m} minutes`;
}

// Slim banner pinned above the app nav, rendered only when the backend reports
// demo-stand mode (GET /api/demo). Invisible on normal instances.
export default function DemoBanner() {
    const [info, setInfo] = useState(null);

    useEffect(() => {
        let cancelled = false;
        getDemoInfo()
            .then(d => { if (!cancelled && d?.demo) setInfo(d); })
            .catch(() => { /* not a demo instance, or offline — no banner */ });
        return () => { cancelled = true; };
    }, []);

    if (!info) return null;

    const interval = formatInterval(info.reset_interval_seconds);
    const resetTime = info.reset_at
        ? new Date(info.reset_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : null;

    return (
        <div
            data-testid="demo-banner"
            style={{
                padding: '6px 16px',
                textAlign: 'center',
                fontSize: '0.8rem',
                lineHeight: 1.5,
                color: 'var(--text-primary)',
                background: 'rgba(245, 158, 11, 0.12)',
                borderBottom: '1px solid rgba(245, 158, 11, 0.35)',
            }}
        >
            <strong>Demo instance</strong> — explore freely, changes are visible to everyone
            {interval && (
                <>
                    {' '}and all data resets every {interval}
                    {resetTime && <> (next reset ~{resetTime})</>}
                </>
            )}
            .
        </div>
    );
}
